// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"f9698bc3","165":"5f735963","172":"29540941","453":"6d36518a","573":"af2323c2","610":"6dfa4da0","652":"48e1bde7"}[chunkId] + ".chunk.js";
};